import Linkify from "linkify-it";

export const linkify = (text, color) => {
  const linkify = Linkify();

  if (linkify.test(text)) {
    const results = linkify.match(text);
    let texts = [];
    let index = 0;

    for (let result of results) {
      if (result.index > index) {
        texts.push(<span>{text.substring(index, result.index)}</span>);
      }
      texts.push(
        <a key={result.url} target="_blank" rel="noreferrer" href={result.url} style={color && {color: color}}>
          {result.text}
        </a>
      );
      index = result.lastIndex;
    }

    if (index < text.length) {
      texts.push(<span>{text.substring(index)}</span>);
    }

    return <div>{texts}</div>;
  }

  return <div>{text}</div>;
};
